<template>
  <div class="params-wrapper">
    <ScrollBar
      :minHeight="450"
      :maxHeight="450"
    >
      <div
        v-for="group in groupedParams"
        :key="group.name"
        class="params-group"
      >
        <h3 class="group-title">{{ group.name }}</h3>

        <table class="params-table">
          <thead>
            <tr>
              <th>Parâmetro</th>
              <th>Descrição</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="item in group.items"
              :key="item.key"
            >
          <td class="param-key">
            <span
              @click="copyParam(item.key)"
              class="param-key-text"
            >
              {{ item.key }} <i class="fa-regular fa-copy icon-copy"></i>
            </span>
          </td>
          <td class="param-desc">{{ item.description }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </ScrollBar>
  </div>
</template>

<script>
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";

export default {
  name: "ParametersInfo",
  components: {
    ScrollBar,
  },
  props: {
    params: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    groupedParams() {
      return [
        {
          name: "Comum",
          items: this.params.filter((p) => p.key.includes("comum")),
        },
        {
          name: "Locacao",
          items: this.params.filter(
            (p) =>
              p.key.includes("locacao.") &&
              !p.key.includes("cliente") &&
              !p.key.includes("colaborador") &&
              !p.key.includes("contato")
          ),
        },
        {
          name: "Cliente",
          items: this.params.filter((p) => p.key.includes("locacao.cliente")),
        },
        {
          name: "Colaborador",
          items: this.params.filter((p) =>
            p.key.includes("locacao.colaborador")
          ),
        },
        {
          name: "Contato",
          items: this.params.filter((p) => p.key.includes("locacao.contato")),
        },
        {
          name: "Periodo",
          items: this.params.filter((p) => p.key.includes("periodo")),
        },
      ];
    },
  },
  methods: {
    copyParam(text) {
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      this.$toasted.show("Parâmetro copiado...", {
        type: "info",
      });
    },
  },
};
</script>

<style scoped>
.params-wrapper {
  padding: 20px;
  background: #fff;
}

.params-group {
  margin-bottom: 30px;
}

.group-title {
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: bold;
}

.params-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e5e7eb;
}

.params-table th {
  background: #f3f4f6;
  padding: 8px;
  text-align: left;
  font-weight: bold;
}

.params-table td {
  padding: 8px;
  border-top: 1px solid #e5e7eb;
}

.param-key {
  font-family: monospace;
  font-size: 13px;
  color: #111827;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.param-key-text {
  word-break: break-all;
  cursor: pointer;
}

.icon-copy {
  color: #6b7280;
}

.param-desc {
  color: #444;
  font-size: 14px;
}
</style>
